module.exports = __webpack_public_path__ + "img/Bannerbeispiel_Sale.095fce21.jpg";